import { useState } from "react";
import { Link } from "react-router-dom";
import { Snowflake, Heart, Leaf, Ghost, Egg, Star, X, ArrowRight } from "lucide-react";
import { isLightColor } from "../lib/tileColor";

const PATTERN_ICON = { snowflakes: Snowflake, hearts: Heart, leaves: Leaf, ghosts: Ghost, eggs: Egg, stars: Star };
const SPOTS = [[4, 20, 18, -12], [14, 70, 12, 20], [27, 30, 22, 8], [41, 75, 14, -20], [55, 18, 16, 15], [68, 65, 24, -6], [80, 25, 13, 25], [92, 70, 20, -15]];
const todayKey = () => new Date().toISOString().slice(0, 10);

export const SeasonalBanner = ({ banner, preview = false }) => {
  const key = `seasonal-banner-${banner.id}`;
  const [hidden, setHidden] = useState(() => !preview && localStorage.getItem(key) === todayKey());
  if (hidden) return null;
  const Icon = PATTERN_ICON[banner.pattern];
  const light = isLightColor(banner.c1) && isLightColor(banner.c2);
  const text = light ? "text-[#12234A]" : "text-white";
  const external = /^https?:\/\//i.test(banner.button_link || "");
  const btnCls = `inline-flex items-center gap-1.5 h-10 px-5 rounded-full text-sm font-bold shadow-sm transition-transform hover:scale-105 ${light ? "bg-[#12234A] text-white" : "bg-white text-[#12234A]"}`;
  const close = () => { localStorage.setItem(key, todayKey()); setHidden(true); };
  return (
    <div className="relative overflow-hidden rounded-2xl mb-3 shadow-md" style={{ background: `linear-gradient(110deg, ${banner.c1}, ${banner.c2})` }} data-testid="seasonal-banner">
      {Icon && SPOTS.map(([x, y, s, r], i) => (
        <Icon key={i} size={s} className={`absolute pointer-events-none ${light ? "text-[#12234A]/15" : "text-white/25"}`} style={{ left: `${x}%`, top: `${y}%`, transform: `rotate(${r}deg)` }} />
      ))}
      <div className="relative flex flex-col sm:flex-row sm:items-center gap-3 px-6 py-4 pr-12">
        <div className="flex-1 min-w-0">
          <p className={`font-display font-extrabold text-lg sm:text-xl ${text}`} data-testid="seasonal-banner-headline">{banner.headline}</p>
          {banner.message && <p className={`text-sm mt-0.5 ${light ? "text-slate-700" : "text-white/90"}`}>{banner.message}</p>}
        </div>
        {banner.button_text && banner.button_link && (external
          ? <a href={banner.button_link} target="_blank" rel="noopener noreferrer" className={btnCls} data-testid="seasonal-banner-btn">{banner.button_text} <ArrowRight size={15} /></a>
          : <Link to={banner.button_link} className={btnCls} data-testid="seasonal-banner-btn">{banner.button_text} <ArrowRight size={15} /></Link>)}
      </div>
      {!preview && (
        <button type="button" onClick={close} aria-label="Hide banner for today" data-testid="seasonal-banner-close"
          className={`absolute top-2.5 right-2.5 h-7 w-7 rounded-full flex items-center justify-center ${light ? "bg-black/5 text-[#12234A]" : "bg-white/20 text-white"} hover:scale-110 transition-transform`}>
          <X size={14} />
        </button>
      )}
    </div>
  );
};
